/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { EntityId, URL } from "./data-contracts";

/**
 * @description Generates a time-limited URL (valid for 1 hour) to preview how a site will look when published. Use this to verify changes before making the site publicly accessible.
 * @tags site-preview
 * @name GetSitePublishingPreviewById
 * @summary Generate a temporary preview URL for a site's published content
 * @request GET:/orgs/{organizationId}/sites/{siteId}/publishing/preview
 * @secure
 */

// @ts-ignore
export const getSitePublishingPreviewById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** ID of the site-space to preview. If not provided, the default site-space will be used. */
    siteSpace?: string;
    /** Rison encoded string of attributes/assertions about the visitor for which we want to preview the site. */
    claims?: string;
    /** ISO 3166-1 alpha-2 code of the country of the visitor for which we want to preview the site. It is matched against the `regions` of the site adaptive schema to resolve `visitor.region`. */
    country?: string;
    /** Whether the visitor for which we want to preview the site is signed in, as `visitor.isAuthenticated` reports it. Claims outside `unsigned` already imply a signed-in visitor; set this to preview one that is signed in while carrying no claim. */
    visitorAuthenticated?: boolean;
    /**
     * Whether to include draft content in the preview. Defaults to true
     * @default true
     */
    draft?: boolean;
    /** Target URL of the preview. If not provided, the default site preview URL will be used. */
    target?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    url: URL;
  };
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/preview",
  method: "get",
  streaming: false,
  tags: ["site-preview"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
